import { login, logout } from '@/api/login'
import { getToken, setToken, removeToken, setUsername, removeUsername } from '@/utils/auth'
import {getsipinfo} from '../../api/csdsip'
import {padphoneauth, padselectusertype} from '../../api/pad/pad'

const user = {
  state: {
    orgid: '',
    orgname: '',
    platform: '',
    role: '',
    scene: '', // 0上海 1中性 2平板 （根据URL区分）
    mqtts: [],
    sipinfo: '',
    isShangHai: true,
    moduletag: '',
    personname: '',
    syspersonjobnum: '',
    syspersonid: '',
    customerservicetag: '',
    LoginResp: '', // 养老院实体机构返回 养老院机构名称  有system_name则显示 无则显示orgname
    auth: '' // 手机号验证码登录实体返回
  },

  mutations: {
    set_orgid (state, orgid) {
      state.orgid = orgid
    },
    set_oegname (state, orgname) {
      state.orgname = orgname
    },
    set_platform (state, platform) {
      state.platform = platform
    },
    set_role (state, role) {
      state.role = role
    },
    set_mqtts (state, mqtts) {
      state.mqtts = mqtts
    },
    set_sipinfo (state, sipinfo) {
      state.sipinfo = sipinfo
    },
    set_moduletag (state, moduletag) {
      state.moduletag = moduletag
    },
    set_sh (state, isShangHai) {
      state.isShangHai = isShangHai
    },
    set_personname (state, personname) {
      state.personname = personname
    },
    set_personjobnum (state, syspersonjobnum) {
      state.syspersonjobnum = syspersonjobnum
    },
    set_syspersonid (state, syspersonid) {
      state.syspersonid = syspersonid
    },
    set_customerservicetag (state, customerservicetag) {
      state.customerservicetag = customerservicetag
    },
    set_LoginResp (state, LoginResp) {
      state.LoginResp = LoginResp
    },
    set_auth (state, auth) {
      state.auth = auth
    },
    set_system_name (state, name) {
      state.LoginResp.system_name = name
    },
    set_scene (state, scene) {
      state.scene = scene
    }
  },

  actions: {
    update_system_name ({commit}, name) {
      commit('set_system_name', name)
    },
    // 登录
    Login ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      commit('set_sh', true)
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          // console.log('login', data)
          setToken(data.token)
          setUsername(username)
          commit('set_scene', userInfo.scene)
          commit('set_orgid', data.orgid)
          commit('set_oegname', data.orgname)
          commit('set_platform', data.platform)
          commit('set_role', data.role)
          commit('set_mqtts', data.mqtts)
          commit('set_moduletag', data.moduletag)

          // 所有权限的：家庭/房间 moduletag: 3
          // 机构权限的：房间 moduletag: 2
          // 小区权限的：家庭 moduletag: 1

          // 机构/房间

          commit('set_personname', data.personname)
          commit('set_personjobnum', data.syspersonjobnum)
          commit('set_syspersonid', data.syspersonid)
          commit('set_customerservicetag', data.customerservicetag)
          commit('set_LoginResp', data.LoginResp)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取客服用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getsipinfo().then(response => {
          const data = response.data
          console.log('客服信息', data)
          commit('set_sipinfo', data.sipinfo)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginAuth ({ commit }, userInfo) {
      const username = userInfo.phone.trim()
      return new Promise((resolve, reject) => {
        padphoneauth(userInfo.phone, userInfo.code).then(response => {
          const data = response.data
          setUsername(username)
          commit('set_auth', data.auth)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginSelectusertype ({ commit }, userInfo) {
      commit('set_sh', true)
      return new Promise((resolve, reject) => {
        padselectusertype(userInfo.typetag, userInfo.muid).then(response => {
          const data = response.data
          setToken(data.loginResp.token)
          commit('set_scene', userInfo.scene)
          commit('set_orgid', data.loginResp.orgid)
          commit('set_oegname', data.loginResp.orgname)
          commit('set_platform', data.loginResp.platform)
          commit('set_role', data.loginResp.role)
          commit('set_mqtts', data.loginResp.mqtts)
          commit('set_moduletag', data.loginResp.moduletag)

          // 所有权限的：家庭/房间 moduletag: 3
          // 机构权限的：房间 moduletag: 2
          // 小区权限的：家庭 moduletag: 1

          // 机构/房间

          commit('set_personname', data.loginResp.personname)
          commit('set_personjobnum', data.loginResp.syspersonjobnum)
          commit('set_syspersonid', data.loginResp.syspersonid)
          commit('set_customerservicetag', data.loginResp.customerservicetag)
          commit('set_LoginResp', data.loginResp)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(getToken()).then(() => {
          commit('set_scene', '')
          commit('set_orgid', '')
          commit('set_oegname', '')
          commit('set_platform', '')
          commit('set_role', '')
          commit('set_mqtts', [])
          commit('set_moduletag', '')
          commit('set_sipinfo', [])
          commit('set_personjobnum', '')
          removeToken()
          removeUsername()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        removeUsername()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js